import { CurrentUser, StepperStep, StepperSteps } from 'types';
import { StepperContent } from './StepperContent';
import { StepperSidebar } from './StepperSidebar';

import styles from './Stepper.module.scss';

export type StepperProps = {
  currentStep: StepperStep;
  contentWrapperStyles?: string;
  passedSteps: string[];
  steps: StepperSteps;
  stepBack?: () => void;
  setStep?: (stepIndex: number) => void;
  stepperName?: string;
  user?: CurrentUser;
  title: string;
};

export const Stepper = ({
  currentStep,
  contentWrapperStyles,
  passedSteps,
  stepperName,
  stepBack,
  setStep,
  steps,
  user,
  title,
}: StepperProps) => {
  if (!currentStep) return null;

  return (
    <div className={styles.container}>
      <StepperSidebar steps={steps} currentStep={currentStep} setStep={setStep} stepperName={stepperName} passedSteps={passedSteps} />
      <StepperContent title={title} step={currentStep} contentWrapperStyles={contentWrapperStyles} stepBack={stepBack} user={user} />
    </div>
  );
};
